import { Helmet } from 'react-helmet-async';
import { Container, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getRewardPostbacks } from '../services/Common/rewardPostback.service';

export default function RewardPostbacksPage() {
    const [rows, setRows] = useState([]);

    useEffect(() => {
        getRewardPostbacks({ limit: 100 })
            .then((result) => setRows(result.items || []))
            .catch(() => toast('Failed to load reward postbacks', { type: 'error' }));
    }, []);

    const columns = [
        { field: 'postedAt', headerName: 'Postback Date', flex: 1, valueGetter: ({ row }) => row.postedAt || row.createdAt || '' },
        { field: 'user', headerName: 'User', flex: 1.2, valueGetter: ({ row }) => row.user?.name || row.user?.email || '' },
        { field: 'email', headerName: 'Email', flex: 1.3, valueGetter: ({ row }) => row.user?.email || '' },
        { field: 'rewardType', headerName: 'Reward Type', flex: 1 },
        { field: 'coinType', headerName: 'Coin', width: 90, valueGetter: ({ row }) => row.coinType?.toUpperCase() || '' },
        { field: 'amount', headerName: 'Amount', width: 100 },
        { field: 'status', headerName: 'Status', width: 110 },
        { field: 'transaction', headerName: 'Transaction ID', flex: 1.4, valueGetter: ({ row }) => row.transaction?._id || row.transaction || '' },
    ];

    return (
        <>
            <Helmet><title>Reward Postbacks | Trooper</title></Helmet>
            <Container>
                <Typography variant="h4" sx={{ mb: 3 }}>Reward Postbacks</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Every successful reward credit is recorded here with its user, source, amount, and transaction.
                </Typography>
                <div style={{ height: '75vh', width: '100%' }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        getRowId={(row) => row._id}
                        pageSizeOptions={[10, 25, 50]}
                    />
                </div>
            </Container>
        </>
    );
}
